import { Breadcrumb, Button, Col, Form, Image, Row, Table, Tooltip, message } from "antd";
import "./cwPendingDocument.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { useLocation, useNavigate } from "react-router-dom";
import { complexDigitToman, convertToJalaliWithTime, delay, fileToformData, validateInput } from "../../../../tools/tools";
import { useEffect, useState } from "react";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import Loading from "../../../auxiliary/loader/loading";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
const CWPendingDocument = () => {
	const [t] = useTranslation("global");

	const { addDocument } = useAPIPublic();
	const { queryLogChangeStatePurchase, updateDocumentCOPurchase } = useDealer();

	const location = useLocation();

	const nav = useNavigate();

	const [frmDoc] = Form.useForm();
	const [purchaseRecord, setPurchaseRecord] = useState([]);
	const [rejectMessage, setRejectMessage] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const [messageApi, contextHolder] = message.useMessage();

	useEffect(() => {
		setPurchaseRecord([location?.state]);
		const handleGetStatus = async () => {
			setPurchaseRecord([location?.state]);
			let response = await queryLogChangeStatePurchase(location?.state?.guD_COPurchaseId);
			if (response) {
				setRejectMessage(response.strDescription);
			}
		};
		handleGetStatus();
	}, []);

	const handleCallBackseller = (value) => {
		frmDoc.setFieldValue("sellerDocument", value);
	};
	const handleCallBackbuyer = (value) => {
		frmDoc.setFieldValue("buyerDocument", value);
	};
	const handleCallBacksim = (value) => {
		frmDoc.setFieldValue("simDocument", value);
	};
	const handleSubmit = async () => {
		try {
			setIsLoading(true);
			let valid = await frmDoc.validateFields();
			if (valid) {
				let resSellerDoc = await addDocument(await fileToformData(valid.sellerDocument, true), "CertNoCard");
				if (resSellerDoc) {
					let resBuyerDoc = await addDocument(await fileToformData(valid.buyerDocument, true), "CertNoCard");
					if (resBuyerDoc) {
						let resSimDoc = await addDocument(await fileToformData(valid.simDocument, true), "CODocument");
						if (resSimDoc) {
							let payload = {
								copurchaseid: location?.state?.guD_COPurchaseId,
								newcertnodocumentid: resBuyerDoc?.Result,
								oldcertnodocumentid: resSellerDoc?.Result,
								codocumentid: resSimDoc?.Result,
							};
							let resUpdate = await updateDocumentCOPurchase(payload);
							if (resUpdate && !resUpdate?.HasError) {
								messageApi.open({
									type: "success",
									content: resUpdate.Message,
								});
								nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.List, {
									replace: true,
								});
							}
						}
					}
				}
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};
	return (
		<>
			{contextHolder}
			<div className="container-main container-sp">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.pending.list.purchase_details") }]}
					/>
					<div className="title-page">
						<h3>{t("changeOwnerShip.pending.list.purchase_details")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main cw-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="cw-pending-document-upload">
									<div className="header-box">
										<div className="row-item">
											<div className="profile">
												<div className="row-profile">
													<div className="hold-icon">
														<i className="icon-user"></i>
													</div>
													<div className="hold-text">
														<h4>{location?.state?.stR_FName + " " + location?.state?.stR_LName}</h4>
														{/* <span>کدملی:{location?.state?.stR_CertNo}</span> */}
													</div>
												</div>
											</div>
											<div className="holder-action">
												<div className="holder-button">
													{/* <Button className="btn-normal btn-print" icon={<i className="icon-print"></i>}>
                            چاپ فاکتور
                          </Button> */}
												</div>
											</div>
										</div>
									</div>
									<div className="holder-table">
										<Table
											className="tbl-normal"
											columns={[
												{
													title: "کدپیگیری",
													dataIndex: "trackcode",
													key: "trackcode",
													width: 150,
												},
												{
													title: "شماره",
													dataIndex: "msisdn",
													key: "msisdn",
													width: 150,
												},
												{
													title: "نوع",
													dataIndex: "type",
													key: "type",
													width: 150,
												},
												{
													title: "قیمت (تومان)",
													dataIndex: "price",
													key: "price",
													width: 150,
												},
												{
													title: "پورسانت (تومان)",
													dataIndex: "commission",
													key: "commission",
													width: 150,
												},
												{
													title: "تاریخ خرید",
													dataIndex: "purchaseDate",
													key: "purchaseDate",
													width: 150,
												},
												{
													title: "وضعیت",
													dataIndex: "status",
													key: "status",
													width: 150,
												},
											]}
											scroll={{ y: "100%" }}
											pagination={{ position: ["none"] }}
											dataSource={purchaseRecord.map((item, key) => ({
												key: key,
												trackcode: item?.stR_COFollowupCode,
												msisdn: item?.inT_MSISDN,
												type: item?.stR_BundleName,
												price: complexDigitToman(item?.inT_PurchaseAmount),
												commission: complexDigitToman(item?.inT_PackageSalesCommission),
												purchaseDate: convertToJalaliWithTime(item?.dtE_OperationDate),
												status: <span className="color-orange">نقص مدرک</span>,
											}))}></Table>
									</div>
									<div className="holder-form">
										<p>
											<strong>علت رد مدرک:</strong> {rejectMessage}
										</p>
										<Form layout="vertical" form={frmDoc}>
											<Row gutter={17}>
												<Col xl={10} lg={12} md={15} xs={24} sm={24}>
													{/* <input type="file" id="uploadFile" /> */}
													<Form.Item name="sellerDocument" rules={[validateInput({ t: t, validate: true })]} label="فروشنده ">
														<>
															<ResizeImage exportImage={handleCallBackseller} />
														</>
													</Form.Item>
												</Col>
												{/* <Col span={9} style={{ margin: "auto 0" }}>
                          <ul>
                            <li>بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی قدیمی همراه با رسید کارت ملی جدید</li>
                            <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                            <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                          </ul>
                        </Col> */}
											</Row>
											<Row gutter={17}>
												<Col xl={10} lg={12} md={15} xs={24} sm={24}>
													<Form.Item name="buyerDocument" rules={[validateInput({ t: t, validate: true })]} label="خریدار">
														<>
															<ResizeImage exportImage={handleCallBackbuyer} />
														</>
													</Form.Item>
												</Col>
												{/* <Col span={9} style={{ margin: "auto 0" }}>
                          <ul>
                            <li>
                              بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت
                              ملی قدیمی همراه با رسید کارت ملی جدید
                            </li>
                            <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                            <li>
                              توضیح در مورد مشخص بودن گوشه های تصویر مدارک
                            </li>
                          </ul>
                        </Col> */}
											</Row>
											<Row gutter={17}>
												<Col xl={10} lg={12} md={15} xs={24} sm={24}>
													<Form.Item name="simDocument" rules={[validateInput({ t: t, validate: true })]} label="سند سیم کارت">
														<>
															<ResizeImage exportImage={handleCallBacksim} />
														</>
													</Form.Item>
												</Col>
												{/* <Col span={9} style={{ margin: "auto 0" }}>
                          <ul>
                            <li>
                              بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت
                              ملی قدیمی همراه با رسید کارت ملی جدید
                            </li>
                            <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                            <li>
                              توضیح در مورد مشخص بودن گوشه های تصویر مدارک
                            </li>
                          </ul>
                        </Col> */}
											</Row>
										</Form>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button type="primary" className="btn-normal btn-aptel" onClick={handleSubmit} danger>
										مرحله بعد
									</Button>
									<Button
										type="default"
										className="btn-normal"
										onClick={() => {
											nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.List);
										}}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>

				{contextHolder}
			</div>
			<Loading isOpen={isLoading} />
		</>
	);
};

export default CWPendingDocument;
